import { ApocalypseFreespinBetPresentation } from "../freespin/ApocalypseFreespinBetPresentation";

export class ApocalypseSuperFreespinBetPresentation extends ApocalypseFreespinBetPresentation {
    constructor(protected id: string = `ApocalypseSuperFreespinBetPresentation`) {
        super(id);
    }
}
